import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id B2DEB97A-B08E-4E10-8E24-A4AF2CF98C74
 * name cards-spade
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cards-spade.svg
 * tags
 * - Gaming / RPG 
 */
export const CardsSpadeIcon = createSvgIcon(<><path d="M12,2C9,7 4,9 4,14C4,16 6,18 8,18C9,18 10,18 11,17C11,17 11.32,19 9,22H15C13,19 13,17 13,17C14,18 15,18 16,18C18,18 20,16 20,14C20,9 15,7 12,2Z" /></>, 'CardsSpadeIcon');
export default CardsSpadeIcon